import * as Yup from 'yup';

import {
  required,
  validEmail,
  passwordValidation,
  invalidPassword,
} from 'features/new-auth/validationSchema';
import { maxLimitMessage } from 'features/checkout/components/ModalAddressForm/validation';

export const noSpaces = (value: string) => value.replace(/\s/g, '');

export function validateBrPhone(value: string) {
  let isValid = false;
  isValid = /^\([1-9]{2}\) [2-9]\d{3,4}-\d{4}$/.test(value);

  if (value !== undefined && isValid) {
    const validators = [
      (phoneNumber: string) => !/^(\d)\1+$/.test(phoneNumber),
      (phoneNumber: string) => !/^(.)\1*$/.test(phoneNumber),
    ];

    const phoneNumber = value.replace(/\W/g, '');
    isValid = validators.every((validator) => validator(phoneNumber));
  }

  return isValid;
}

export const emailFormValidation = Yup.object({
  email: Yup.string()
    .trim()
    .max(64, maxLimitMessage(64))
    .required(required)
    .email(validEmail),
  password: Yup.string()
    .required(required)
    .max(20, maxLimitMessage(20))
    .matches(
      /^[\w!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|`~]+$/,
      'Senha não pode conter espaços ou emojis',
    )
    .test(
      'password-validation',
      invalidPassword,
      (value) =>
        typeof value === 'string' && passwordValidation(value).isValidPassword,
    ),
});

export const personalFormValidation = Yup.object({
  name: Yup.string()
    .trim()
    .required(required)
    .max(128, maxLimitMessage(128))
    .test(
      'has-two-names',
      'Informe o nome completo',
      (value) => !!value && value.trim().split(/\s+/).length >= 2,
    ),
  billingPhone: Yup.string()
    .required(required)
    .test(
      'br-phone',
      'Telefone inválido',
      (value) => typeof value === 'string' && validateBrPhone(value),
    ),
  coupon: Yup.string().max(20, maxLimitMessage(20)),
});

export const specialtyFormValidation = Yup.object({
  cbo: Yup.string().trim().required(required),
});
